import mixpanel from "mixpanel-browser";

mixpanel.init('775f57a77ee532e28a014100beb59490', { debug: true, track_pageview: true, persistence: 'localStorage' });

export { mixpanel }